var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUwalk14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 114,
    viewBox: "0 0 115 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_390_4106)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12,
    width: 87,
    height: 87,
    rx: 3.40448,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.7701 31.9181C64.0912 32.136 55.9557 26.2349 50.3282 26.3413C44.7007 26.4477 32.939 29.9049 33.4237 55.7961C33.9084 81.6873 49.8806 85.1901 56.0722 85.0753C85.0592 84.5331 96.4561 31.5313 75.7701 31.9181Z",
    fill: "url(#paint0_linear_390_4106)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2979 35.3633H86.6757V37.0522H83.2979V35.3633Z",
    fill: "#D4D8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.585 35.3633H76.9628V37.0522H73.585V35.3633Z",
    fill: "#D4D8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4961 29.4531H81.185V32.831H79.4961V29.4531Z",
    fill: "#D4D8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4961 39.1641H81.185V42.5419H79.4961V39.1641Z",
    fill: "#D4D8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8742 77.5853C29.4775 77.5853 28.3408 76.4487 28.3408 75.0519C28.3408 73.6552 29.4775 72.5186 30.8742 72.5186C32.2709 72.5186 33.4076 73.6552 33.4076 75.0519C33.4076 76.4487 32.2709 77.5853 30.8742 77.5853ZM30.8742 74.2075C30.4081 74.2075 30.0297 74.5875 30.0297 75.0519C30.0297 75.5164 30.4081 75.8964 30.8742 75.8964C31.3403 75.8964 31.7187 75.5164 31.7187 75.0519C31.7187 74.5875 31.3403 74.2075 30.8742 74.2075Z",
    fill: "#D4D8FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8638 40.0442C61.6979 40.0442 59.9365 38.2576 59.9365 36.0607C59.9365 33.8638 61.6979 32.0771 63.8638 32.0771C66.0297 32.0771 67.7911 33.8638 67.7911 36.0607C67.7911 38.2576 66.0297 40.0442 63.8638 40.0442ZM63.8638 35.0648C63.3218 35.0648 62.882 35.5129 62.882 36.0607C62.882 36.6084 63.3218 37.0565 63.8638 37.0565C64.4058 37.0565 64.8456 36.6084 64.8456 36.0607C64.8456 35.5129 64.4058 35.0648 63.8638 35.0648Z",
    fill: "#433ED1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8638 55.9787C61.6979 55.9787 59.9365 54.1921 59.9365 51.9952C59.9365 49.7983 61.6979 48.0117 63.8638 48.0117C66.0297 48.0117 67.7911 49.7983 67.7911 51.9952C67.7911 54.1921 66.0297 55.9787 63.8638 55.9787ZM63.8638 50.9994C63.3218 50.9994 62.882 51.4475 62.882 51.9952C62.882 52.543 63.3218 52.9911 63.8638 52.9911C64.4058 52.9911 64.8456 52.543 64.8456 51.9952C64.8456 51.4475 64.4058 50.9994 63.8638 50.9994Z",
    fill: "#433ED1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1177 48.011C47.9518 48.011 46.1904 46.2244 46.1904 44.0275C46.1904 41.8306 47.9518 40.0439 50.1177 40.0439C52.2836 40.0439 54.045 41.8306 54.045 44.0275C54.045 46.2244 52.2836 48.011 50.1177 48.011ZM50.1177 43.0316C49.5757 43.0316 49.1359 43.4797 49.1359 44.0275C49.1359 44.5752 49.5757 45.0233 50.1177 45.0233C50.6597 45.0233 51.0995 44.5752 51.0995 44.0275C51.0995 43.4797 50.6597 43.0316 50.1177 43.0316Z",
    fill: "#433ED1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5049 46.6094L52.954 44.0071L62.4874 49.4694L61.0382 52.0716L51.5049 46.6094Z",
    fill: "#433ED1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5322 41.4883L61.03 35.9896L62.491 38.5858L52.9932 44.0845L51.5322 41.4883Z",
    fill: "#433ED1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0637 79.8783H35.8819C35.069 79.8783 34.4092 79.209 34.4092 78.3845V73.4051C34.4092 70.3836 36.8303 67.9277 39.8092 67.9277H53.1619V70.9154H39.8092C38.4562 70.9154 37.3546 72.0327 37.3546 73.4051V76.8906H78.5909V73.4051C78.5909 72.0327 77.4893 70.9154 76.1364 70.9154H62.7837V67.9277H76.1364C79.1152 67.9277 81.5364 70.3836 81.5364 73.4051V78.3845C81.5364 79.209 80.8766 79.8783 80.0637 79.8783Z",
    fill: "#433ED1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4033 69.9854L79.0372 37.7296L81.8795 38.5123L73.2457 70.7681L70.4033 69.9854Z",
    fill: "#433ED1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0771 38.4893L36.9195 37.7065L45.5534 69.9623L42.711 70.745L34.0771 38.4893Z",
    fill: "#433ED1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.972 73.9037C54.7241 73.9037 52.0811 71.2228 52.0811 67.9284C52.0811 64.634 54.7241 61.9531 57.972 61.9531C61.2198 61.9531 63.8629 64.634 63.8629 67.9284C63.8629 71.2228 61.2198 73.9037 57.972 73.9037ZM57.972 64.9408C56.348 64.9408 55.0265 66.2812 55.0265 67.9284C55.0265 69.5756 56.348 70.916 57.972 70.916C59.5959 70.916 60.9174 69.5756 60.9174 67.9284C60.9174 66.2812 59.5959 64.9408 57.972 64.9408Z",
    fill: "#433ED1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_390_4106",
    x: 0.722534,
    y: 0.0843256,
    width: 113.555,
    height: 113.555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.36179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.63873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_390_4106"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_390_4106",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_390_4106",
    x1: 59.8652,
    y1: 26.3398,
    x2: 59.8652,
    y2: 85.0779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F2FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUwalk14);
export default __webpack_public_path__ + "static/media/uwalk14.6f61a6751f80dacaeaf5d0d9ea27051b.svg";
export { ForwardRef as ReactComponent };